/**
 * Longest the kiosk holds the final screen's Okay button while the
 * card-on-file authorization records. The machine gives up on the write after
 * this long, and FinalScreen re-enables Okay after this long on its own, so a
 * stale `cardAuthRecording` flag (e.g. restored after a page refresh, which
 * does not re-run the recording step) can never lock the patient out.
 */
export const CARD_AUTH_RECORDING_TIMEOUT_MS = 10_000;
